import cx from 'classnames';
import { MutableRefObject } from 'react';
import { Dropdown } from './RangeInput.styles';

type OwnProps = {
  activeDescendantIndex: string;
  filterKey: string;
  handleItemSelect: (v: number, i: string) => void;
  isMouseOverDropdownRef: MutableRefObject<boolean>;
  rangeOptions: number[];
  rangeType: string;
  showDropdown: boolean;
  useMouseHoverStyleRef: MutableRefObject<boolean>;
};

export default function DropdownList({
  activeDescendantIndex,
  filterKey,
  handleItemSelect,
  isMouseOverDropdownRef,
  rangeOptions,
  rangeType,
  showDropdown,
  useMouseHoverStyleRef
}: OwnProps) {
  return (
    <Dropdown
      className={showDropdown ? 'block' : 'hidden'}
      id={`${filterKey}-${rangeType}-options`}
      onMouseEnter={() => (isMouseOverDropdownRef.current = true)}
      onMouseLeave={() => (isMouseOverDropdownRef.current = false)}
    >
      {rangeOptions?.map((v, i) => (
        <li
          aria-selected={i === Number(activeDescendantIndex)}
          className={cx('hover:bg-blue-6 hover:text-white p-16 text-left', {
            'bg-blue-6 text-white':
              i === Number(activeDescendantIndex) &&
              !useMouseHoverStyleRef.current
          })}
          data-analytics-id={`${filterKey}-range-input-${rangeType}-option-${v}`}
          id={`${rangeType}-${filterKey}-${v}`}
          key={`${rangeType}-${filterKey}-${v}`}
          onClick={() => {
            handleItemSelect(v, i.toString());
          }}
          role="option"
        >
          ${v.toLocaleString()}
        </li>
      ))}
    </Dropdown>
  );
}
